<template>
  <div class="top">
    <link rel="stylesheet" href="//fonts.googleapis.com/icon?family=Material+Icons">
    <md-icon>home</md-icon> {{ $i18n.locale }} {{ $t('hello') }}
    <md-card>
      <md-card-header>
	<div class="md-title">JCID Inquiry Request Test</div>
      </md-card-header>
      <md-card-content>
	<md-input-container style="width:80%;">
	  <label>Request URL</label>
	  <md-input></md-input>
	</md-input-container>
	<md-input-container style="width:140px;">
	  <label>UserID</label>
	  <md-input v-model="userID"></md-input>
	</md-input-container>
	<div style="text-align:left;">
	  <label style="width:90%">XML_Content</label><br/>
	  <textarea style="width:90%; height:20em;"></textarea>
	</div>
	<div style="text-align:right;">
  	  <!--
	  <md-button class="md-raised" @click.native="openDialog('result')">Submit</md-button>
	  -->
	  <md-button class="md-raised" @click.native="submitInquiry">Submit</md-button>
	</div>
      </md-card-content>
    </md-card>
    <md-dialog ref="result">
      <md-dialog-title>Result</md-dialog-title>
      <md-dialog-content>
	<textarea style="width:590px;; height:20em">{{ result }}</textarea>
      </md-dialog-content>
      <md-dialog-actions>
	<md-button class="md-primary" @click.native="closeDialog('result')">Ok</md-button>
      </md-dialog-actions>
    </md-dialog>
    <!--
    <md-dialog-alert
       :md-content-html="result"
       md-ok-text="ok"
       @open="onOpen"
       @close="onClose"
       ref="result2">
      def
    </md-dialog-alert> -->
    <router-link :to="{name: 'Mdf', params: {id: '100entry--R110h-1_25-2321Y'}}">mdf</router-link>
  </div>
</template>
<!-- vue-i18n-loaderがうまく動かないみたいなのでやめ
<i18n>
{
    "en": {
	"hello": "Hello world!"
    },
    "ja": {
	"hello": "こんにちは、世界!"
    }
}
</i18n>
-->
<script>
//import axios from 'axios'
  
export default {
  data() {
    return {
	userID: 'NEC_API_USER',
	result: 'ok',
	initialValue: 'My initial value'
    };
  },
  methods: {
    submitInquiry() {
	axios.get('/static/response.xml', {})
	    .then( res => {
		if("OK" == res.statusText) {
		    this.result = res.data
		} else {
		    this.result = "response error: "+res.statusText
		}
		this.openDialog('result')
	    })
	    .catch(error => {
		this.result = error
		this.openDialog('result')
	    })
    },
    openDialog(ref) {
      this.$refs[ref].open();
    },
    closeDialog(ref) {
      this.$refs[ref].close();
    },
    onOpen() {
      console.log('Opened');
    },
    onClose(type) {
      console.log('Closed', type);
    },
  },
    beforeMount() {
	//console.log(this.$options)
	//<i18n>タグが動かないようなので
	this.$i18n.setLocaleMessage('en', {
	    "hello": "Hoge"
	})
	this.$i18n.setLocaleMessage('ja', {
	    "hello": "こんにちは"
	})
	this.$i18n.locale = "ja"
	// console.log(this.$t('hello'))
    }
};
</script>
<style src="../assets/vue-material.css"></style>
<style>
div .top {
margin: 20px;
text-align: left;
}
</style>



// WEBPACK FOOTER //
// Material.vue?4e71434d